/**
 * @generated SignedSource<<e5d6ba0a009e7fc891cd2c8fb78035a7>>
 * @relayHash ad186289ef62024b12fcc73c9d3f1fc4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d2ddaf0f697293f5dca13c09cc8522d351af5e0214b7be65b1533696abd0ccf5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FirstCreateViewQuery } from './FirstCreateViewQuery.graphql';

const node: PreloadableConcreteRequest<FirstCreateViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d2ddaf0f697293f5dca13c09cc8522d351af5e0214b7be65b1533696abd0ccf5",
    "metadata": {},
    "name": "FirstCreateViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
